module.exports = __webpack_public_path__ + "img/35.d3a38856.jpg";